import { useCallback } from "react";
import {
  BidV2Status,
  SourcingEventStatus,
  type BuyerBidV2DetailDto,
  useGetSourcingEventQuery,
  useRevokeBidRejectionMutation,
} from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";

export interface BidRejectionDecision {
  isRejected: boolean;
  canRevoke: boolean;
  revoke: () => Promise<boolean>;
  isLoading: boolean;
}

export const useBidRejectionDecision = (detail: BuyerBidV2DetailDto): BidRejectionDecision => {
  const { triggerSoft } = useApiError();
  const [revokeRejection, { isLoading }] = useRevokeBidRejectionMutation();
  const { data: event } = useGetSourcingEventQuery({ eventId: detail.bid.forEvent });

  const eventId = detail.bid.forEvent;
  const bidId = detail.bid.id;
  const isRejected = detail.bid.status === BidV2Status.Rejected;

  const revoke = useCallback(async () => {
    try {
      await revokeRejection({ eventId, bidId }).unwrap();
      return true;
    } catch (e) {
      triggerSoft(e);
      return false;
    }
  }, [revokeRejection, eventId, bidId, triggerSoft]);

  return {
    isRejected,
    canRevoke: isRejected && event?.status === SourcingEventStatus.Published,
    revoke,
    isLoading,
  };
};
